module.exports = __webpack_public_path__ + "static/media/search.73d324c5.svg";